module.exports = __webpack_public_path__ + "img/achievement3.8e48b105.jpeg";